import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Student Grievance</h1>
                <p>Home &gt; Student Grievance</p>
            </div>
        </div>
    )
}

export default Hero;